import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition } from "vue"
import _imports_0 from '../../assets/logoCuraduria.jpg'
import _imports_1 from '../../assets/logoCuraduria.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex py-4 w-full bg-white justify-center md:justify-center md:space-x-6 lg:flex-1" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-16 w-auto sm:h-12 md:h-24 md:w-60 z-60",
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_2 = { class: "w-full mx-auto px-4 sm:px-6" }
const _hoisted_3 = { class: "flex justify-start items-center py-6 md:justify-center md:space-x-6" }
const _hoisted_4 = { class: "-mr-2 -my-2 md:hidden" }
const _hoisted_5 = {
  href: "/",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_6 = {
  href: "/nosotros",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_7 = {
  href: "/documentos",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_8 = {
  href: "/consultas",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_9 = {
  href: "/resoluciones",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_10 = {
  href: "/transparencia",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_11 = {
  href: "/normatividad",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_12 = {
  href: "/licencias",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_13 = {
  href: "/contacto",
  class: "text-lg font-medium text-white hover:text-gray-900"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" PQRSDF ")
const _hoisted_15 = { class: "rounded-md shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50" }
const _hoisted_16 = { class: "pt-5 pb-6 px-5" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-14 w-auto",
    src: _imports_1,
    alt: "Curaduria2"
  })
], -1)
const _hoisted_19 = { class: "-mr-2" }
const _hoisted_20 = { class: "mt-8" }
const _hoisted_21 = { class: "grid gap-y-8" }
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = {
  href: "/",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_24 = { class: "flex flex-row" }
const _hoisted_25 = {
  href: "/nosotros",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_26 = { class: "flex flex-row" }
const _hoisted_27 = {
  href: "/documentos",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_28 = { class: "rounded-lg shadow-lg overflow-hidden" }
const _hoisted_29 = { class: "relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "ml-4" }
const _hoisted_32 = { class: "text-base font-medium text-gray-900" }
const _hoisted_33 = { class: "flex flex-row" }
const _hoisted_34 = {
  href: "/consultas",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_35 = { class: "flex flex-row" }
const _hoisted_36 = {
  href: "/resoluciones",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_37 = { class: "flex flex-row" }
const _hoisted_38 = {
  href: "/transparencia",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_39 = { class: "flex flex-row" }
const _hoisted_40 = {
  href: "/normatividad",
  class: "text-lg font-medium text-curaduria text-lg ml-3 hover:text-gray-900"
}
const _hoisted_41 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_42 = { class: "relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "ml-4" }
const _hoisted_45 = { class: "text-base font-medium text-gray-900" }
const _hoisted_46 = { class: "flex flex-row" }
const _hoisted_47 = {
  href: "/contacto",
  class: "text-lg font-medium text-curaduria ml-3 hover:text-gray-900"
}
const _hoisted_48 = { class: "flex flex-row" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" PQRSDF ")
const _hoisted_50 = { class: "flex flex-row" }

import {
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/vue";
import Locale from "./Locale.vue";
import { MenuIcon, XIcon } from "@heroicons/vue/outline";
import {
  LibraryIcon,
  FolderIcon,
  HomeIcon,
  UserCircleIcon,
  QuestionMarkCircleIcon,
  DocumentTextIcon,
  BookOpenIcon,
  UsersIcon,
  ClipboardListIcon,
} from "@heroicons/vue/solid";
import { CursorClickIcon, ChevronDownIcon } from "@heroicons/vue/outline";
import "../../styles/app.css";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const documents = [
  {
    name: "Concepto uso de suelo",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Concepto normatividad urbana",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Corrección de texto",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para licencia de subdivisión",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para ajuste de cotas y áreas",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para aprobación de planos propiedad horizontal",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para licencia de parcelación",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para licencia de urbanismo",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para licencia de construcción",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Documento para requerimiento de edificaciones",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Movimiento de tierra",
    href: "/documentos",
    icon: CursorClickIcon,
  },
  {
    name: "Prorroga de licencia",
    href: "/documentos",
    icon: CursorClickIcon,
  },
];

const normatividad = [
  {
    name: "Ciudad Norte",
    href: "/normatividad/#norte",
    icon: CursorClickIcon,
  },
  {
    name: "Ciudad Centro",
    href: "/normatividad/#centro",
    icon: CursorClickIcon,
  },
  {
    name: "Ciudad Sur",
    href: "/normatividad/#sur",
    icon: CursorClickIcon,
  },
  {
    name: "Borde Occidental",
    href: "/normatividad/#occidental",
    icon: CursorClickIcon,
  },
  {
    name: "Borde Oriental",
    href: "/normatividad/#oriental",
    icon: CursorClickIcon,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Popover), { class: "relative svgContent" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(PopoverButton), { class: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-curaduria focus:outline-none focus:ring-2 focus:ring-inset focus:ring-curaduria" }, {
              default: _withCtx(() => [
                _createVNode(_unref(MenuIcon), {
                  class: "h-6 w-6",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(PopoverGroup), {
            as: "nav",
            class: "accessibility-main-nav hidden md:flex space-x-10 z-50"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("menu.home")), 1),
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t("menu.us")), 1),
              _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("menu.documents")), 1),
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("menu.consultas")), 1),
              _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t("menu.resoluciones")), 1),
              _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t("menu.transparencia")), 1),
              _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t("menu.normatividad")), 1),
              _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t("menu.tramite")), 1),
              _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t("menu.contact")), 1),
              _createVNode(_component_router_link, {
                to: "/pqrsdf",
                class: "text-lg font-medium text-white hover:text-gray-900"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(Locale)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "duration-200 ease-out",
        "enter-from-class": "opacity-0 scale-95",
        "enter-to-class": "opacity-100 scale-100",
        "leave-active-class": "duration-100 ease-in",
        "leave-from-class": "opacity-100 scale-100",
        "leave-to-class": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PopoverPanel), {
            focus: "",
            class: "absolute top-0 inset-x-0 p-2 transition transform origin-top-right popover md:hidden"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_unref(PopoverButton), { class: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-curaduria focus:outline-none focus:ring-2 focus:ring-inset focus:ring-curaduria" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(XIcon), {
                            class: "h-6 w-6",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("nav", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_unref(HomeIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createElementVNode("a", _hoisted_23, _toDisplayString(_ctx.$t("menu.home")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_unref(UsersIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createElementVNode("a", _hoisted_25, _toDisplayString(_ctx.$t("menu.us")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_unref(FolderIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createVNode(_unref(Popover), { class: "relative" }, {
                          default: _withCtx(({ open }) => [
                            _createVNode(_unref(PopoverButton), {
                              class: _normalizeClass([
                      open ? 'text-white' : 'text-white',
                      'group rounded-md inline-flex items-center text-base font-medium hover:text-gray-500',
                    ])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_27, _toDisplayString(_ctx.$t("menu.documents")), 1),
                                _createVNode(_unref(ChevronDownIcon), {
                                  class: _normalizeClass([
                        open ? 'text-curaduria' : 'text-curaduria',
                        'ml-2 h-5 w-5 group-hover:text-gray-900',
                      ]),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createVNode(_Transition, {
                              "enter-active-class": "transition ease-out duration-200",
                              "enter-from-class": "opacity-0 translate-y-1",
                              "enter-to-class": "opacity-100 translate-y-0",
                              "leave-active-class": "transition ease-in duration-150",
                              "leave-from-class": "opacity-100 translate-y-0",
                              "leave-to-class": "opacity-0 translate-y-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverPanel), { class: "absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(documents, (item) => {
                                          return _createElementVNode("a", {
                                            key: item.name,
                                            href: item.href,
                                            class: "-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                          }, [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                              class: "flex-shrink-0 h-6 w-6 text-curaduria",
                                              "aria-hidden": "true"
                                            })),
                                            _createElementVNode("div", _hoisted_31, [
                                              _createElementVNode("p", _hoisted_32, _toDisplayString(item.name), 1)
                                            ])
                                          ], 8, _hoisted_30)
                                        }), 64))
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_unref(LibraryIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createElementVNode("a", _hoisted_34, _toDisplayString(_ctx.$t("menu.consultas")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_unref(DocumentTextIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createElementVNode("a", _hoisted_36, _toDisplayString(_ctx.$t("menu.resoluciones")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_unref(BookOpenIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.$t("menu.transparencia")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_unref(ClipboardListIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createVNode(_unref(Popover), { class: "relative" }, {
                          default: _withCtx(({ open }) => [
                            _createVNode(_unref(PopoverButton), {
                              class: _normalizeClass([
                      open ? 'text-white' : 'text-white',
                      'group rounded-md inline-flex items-center text-base font-medium hover:text-gray-500',
                    ])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t("menu.normatividad")), 1),
                                _createVNode(_unref(ChevronDownIcon), {
                                  class: _normalizeClass([
                        open ? 'text-curaduria' : 'text-curaduria',
                        'ml-2 h-5 w-5 group-hover:text-gray-900',
                      ]),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createVNode(_Transition, {
                              "enter-active-class": "transition ease-out duration-200",
                              "enter-from-class": "opacity-0 translate-y-1",
                              "enter-to-class": "opacity-100 translate-y-0",
                              "leave-active-class": "transition ease-in duration-150",
                              "leave-from-class": "opacity-100 translate-y-0",
                              "leave-to-class": "opacity-0 translate-y-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PopoverPanel), { class: "absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(normatividad, (item) => {
                                          return _createElementVNode("a", {
                                            key: item.name,
                                            href: item.href,
                                            class: "-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
                                          }, [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                              class: "flex-shrink-0 h-6 w-6 text-curaduria",
                                              "aria-hidden": "true"
                                            })),
                                            _createElementVNode("div", _hoisted_44, [
                                              _createElementVNode("p", _hoisted_45, _toDisplayString(item.name), 1)
                                            ])
                                          ], 8, _hoisted_43)
                                        }), 64))
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_unref(UserCircleIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createElementVNode("a", _hoisted_47, _toDisplayString(_ctx.$t("menu.contact")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_unref(QuestionMarkCircleIcon), { class: "flex-shrink-0 h-6 w-6 text-curaduria" }),
                        _createVNode(_component_router_link, {
                          to: "/pqrsdf",
                          class: "text-lg font-medium text-curaduria ml-3 hover:text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(Locale)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})